import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faCar, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { primaryColor } from "../../../../../../utils/comon";
import apiServices from "../../../../../../services/apiService";

const VEHICLE_TYPES = ["Car", "Bike", "Other"];

const VehicleParking = ({ formData, onUpdate, onNext, onBack, siteId, slotsUrl }) => {
  const primary = primaryColor();
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!siteId) {
      setLoading(false);
      return;
    }
    const fetchSlots = async () => {
      try {
        const response = await apiServices({
          method: "GET",
          url: slotsUrl,
          params: { siteId }
        });
        const body = response?.data || {};
        if (body.IsSuccess === true || body.isSuccess === true) {
          setSlots(body.Data || body.data || []);
        }
      } catch (err) {
        console.error("Error fetching parking slots:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSlots();
  }, [siteId, slotsUrl]);

  const slotId = (slot) => slot.Id ?? slot.id;
  const slotName = (slot) => slot.SlotNumber ?? slot.slotNumber;

  const toggleSlot = (slot) => {
    const id = slotId(slot);
    onUpdate({ parkingSlotId: formData.parkingSlotId === id ? null : id });
  };

  const needsVehicle = formData.parkingSlotId && !formData.vehicleNumber?.trim();

  return (
    <div className="flex-1 flex flex-col h-full bg-[#F6F6F4]">
      <div className="flex-1 overflow-y-auto px-6 pt-8 pb-4">
        <p className="text-2xl font-black tracking-tight leading-none text-center cursor-pointer"
          style={{ color: primary }}
          onClick={() => window.open("https://myhello.in/", "_blank")}
        >
          Hello!
        </p>
        <h1 className="text-sm font-black text-[#191C1D] mt-4 leading-tight">Vehicle & Parking (optional)</h1>

        <div className="flex items-center gap-1.5 mt-2 mb-6">
          <div className="w-1 h-1 rounded-full bg-gray-200" />
          <div className="w-1 h-1 rounded-full bg-gray-200" />
          <div className="w-4 h-1 rounded-full" style={{ backgroundColor: primary }} />
        </div>

        <label className="text-[10px] font-bold text-gray-500 uppercase">Vehicle number</label>
        <input
          type="text"
          placeholder="e.g. MH12AB1234"
          className="w-full bg-white border border-gray-100 rounded-lg py-2 px-3 mt-1 mb-4 text-xs font-semibold uppercase outline-none shadow-sm"
          value={formData.vehicleNumber || ""}
          onChange={(e) => onUpdate({ vehicleNumber: e.target.value.toUpperCase() })}
        />

        <label className="text-[10px] font-bold text-gray-500 uppercase">Vehicle type</label>
        <div className="flex gap-2 mt-1 mb-6">
          {VEHICLE_TYPES.map((type) => {
            const active = formData.vehicleType === type;
            return (
              <button
                key={type}
                type="button"
                onClick={() => onUpdate({ vehicleType: active ? "" : type })}
                className="flex-1 py-2 rounded-lg text-xs font-black border-2 transition-all"
                style={{ borderColor: active ? primary : "#E5E7EB", color: active ? primary : "#475569", backgroundColor: "#fff" }}
              >
                {type}
              </button>
            );
          })}
        </div>

        <p className="text-[10px] font-bold text-gray-500 uppercase mb-2">Pay & Park slot</p>
        {loading ? (
          <div className="flex justify-center items-center py-6">
            <div className="w-6 h-6 border-4 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : slots.length === 0 ? (
          <p className="text-xs text-gray-500">No free Pay & Park slots right now. You can continue without parking.</p>
        ) : (
          <div className="grid grid-cols-3 gap-2">
            {slots.map((slot) => {
              const selected = formData.parkingSlotId === slotId(slot);
              return (
                <button
                  key={slotId(slot)}
                  type="button"
                  onClick={() => toggleSlot(slot)}
                  className="relative p-3 rounded-lg border-2 bg-white text-left transition-all"
                  style={{ borderColor: selected ? primary : "transparent" }}
                >
                  {selected && (
                    <FontAwesomeIcon icon={faCheckCircle} className="absolute top-1.5 right-1.5 text-xs" style={{ color: primary }} />
                  )}
                  <FontAwesomeIcon icon={faCar} className="text-gray-400 text-xs" />
                  <p className="text-sm font-black mt-1" style={{ color: selected ? primary : "#191C1D" }}>{slotName(slot)}</p>
                </button>
              );
            })}
          </div>
        )}
        {formData.parkingSlotId && (
          <p className="text-[10px] text-gray-500 mt-3">
            If the unit needs approval, the slot is held for you until the unit admin approves.
          </p>
        )}
        {needsVehicle && (
          <p className="text-[10px] font-bold text-red-500 mt-2">Enter the vehicle number to reserve a slot.</p>
        )}
      </div>

      <div className="px-2 py-3 bg-white flex gap-3 border-t border-gray-50">
        <button
          onClick={onBack}
          className="flex-1 py-2 rounded-lg bg-white text-xs font-black flex items-center justify-center gap-2 active:scale-95 transition-all shadow-sm"
          style={{ border: `2px solid ${primary}`, color: primary }}
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Back
        </button>
        <button
          onClick={onNext}
          disabled={needsVehicle}
          className="flex-[2] py-2 rounded-lg text-white text-sm font-black flex items-center justify-center gap-2 disabled:opacity-50 active:scale-95 transition-all shadow-lg"
          style={{ backgroundColor: primary }}
        >
          Generate Pass <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
    </div>
  );
};

export default VehicleParking;
